export var TplTypes;
(function (TplTypes) {
    TplTypes["List"] = "list";
    TplTypes["Form"] = "form";
    TplTypes["Any"] = "any";
    TplTypes["Universal"] = "universal";
    TplTypes["UniversalRead"] = "universal_read";
    TplTypes["Auth"] = "auth";
})(TplTypes || (TplTypes = {}));
export var IDataSourceTypes;
(function (IDataSourceTypes) {
    IDataSourceTypes["HTTP"] = "http";
    IDataSourceTypes["DB"] = "db";
    IDataSourceTypes["DB_JOIN"] = "db_join";
    IDataSourceTypes["COMBINE_DATA"] = "combineData";
    IDataSourceTypes["WUJI_1_0"] = "wuji1_0";
    IDataSourceTypes["SQL"] = "sql";
    IDataSourceTypes["CODE"] = "code";
    IDataSourceTypes["FRONT_END_HTTP"] = "frontEndHttp";
    IDataSourceTypes["ER"] = "er";
})(IDataSourceTypes || (IDataSourceTypes = {}));
export var IVersionControl;
(function (IVersionControl) {
    IVersionControl[IVersionControl["Origin"] = 0] = "Origin";
    IVersionControl[IVersionControl["Row"] = 1] = "Row";
})(IVersionControl || (IVersionControl = {}));
